<template>
  <div id="app">
    <keep-alive>
      <router-view ref="childpage" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view ref="childpage" v-if="!$route.meta.keepAlive"></router-view>
    <div v-if="show_deploy" class="no-content">
			<div class="img-part"><img src="images/upgrade.png" /></div>
			<div class="text-part">Sorry, Our website is under maintenance, We will be back soonest, Please wait.</div>
		</div>
		<div v-if="show_illegal" class="no-content">
			<div class="img-part"><img src="images/forbidden.png" /></div>
			<div class="text-part">Your country and region is currently forbidden, Unable to access this site.</div>
		</div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
export default {
  data() {
    return {
      show_deploy: false,
      show_illegal: false,
    };
  },
  methods: {
    checkIsMobile() {
      const userAgentInfo = navigator.userAgent;
      const mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
      for (let i = 0; i < mobileAgents.length; i++) {
        if (userAgentInfo.indexOf(mobileAgents[i]) > 0) {
          return true;
        }
      }
      return false;
    },
    topage(path) {
      if (path != this.$route.path) {
        this.$router.push(path);
      }
    },
  },
  created: function () {
    if(!this.checkIsMobile() && window.innerWidth >= 1200) {
      this.$router.push('/pcview');
    }
    import("@/assets/styles/base.css");
    if (this.util.isPC()) import("@/assets/styles/w.css");
    else import("@/assets/styles/m.css");
  }
};
</script>

<style lang="scss">
.mui-popup-button:first-child:last-child {
  border-radius: 4px!important;
  background: #628808!important;
  border: none!important;
}

#app {
    width: 100%;
    height: 100%;

    .tradingview-widget-container {
      width: 100%;
    }
  
    .no-content {
      width: 100%;
      height: 100%;
      background-color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 999;
      transform: translateX(-50%) translateY(-50%);
    } 
  
    .no-content .img-part {
      margin-top: 15px;
          img {
          display: block;
          margin: auto;
          width: 3rem;
          height: auto;
        }
    }

    .no-content .text-part {
      width: 90%;
      margin: auto;
      margin-top: 5px;
      text-align: center;
      font-size: 0.5rem;
      font-weight: bold;
      color:black;
    }
}
.mui-toast-message {
  font-size: 0.34rem;
  font-weight: bolder;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>